import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    description:
      '{stakeToken} is a liquid staking token that allows users to access DeFi opportunities while their original {mainToken} remains staked and continues earning rewards. Its redemption value increases over time as staking rewards accumulate, while the token quantity stays fixed.',
  },
};
